import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAlertData, IAlertDataButton } from '../../interfaces/utils/utils.interface';
import { AlertService } from '../../services/alert/alert.service';
import { AlertStatus } from '../../enums/common.enum';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { checkmark, handRight, help, warningOutline } from 'ionicons/icons';

@Component({
  selector: 'mob-alert-shared',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  templateUrl: './mob-alert-shared.component.html',
  styleUrl: './mob-alert-shared.component.scss',
})
export class MobAlertSharedComponent implements OnInit {


  @Output() closeAlert: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected componentInputs: {
    code?: number;
  } = {
    code: undefined,
  };

  private _alertData: IAlertData | undefined = undefined;

  constructor(private alertService: AlertService,
              private changeDetectorRef: ChangeDetectorRef) {

      addIcons({handRight, checkmark, warningOutline, help})
  }

  @Input() set alertData(alertData: IAlertData) {
    if (!alertData.icon || alertData.icon === '') {
      switch (alertData.status) {
        case AlertStatus.error:
          alertData.icon = 'hand-right';
          break;
        case AlertStatus.success:
          alertData.icon = 'checkmark';
          break;
        case AlertStatus.warning:
          alertData.icon = 'warning-outline';
          break;
        case AlertStatus.question:
          //alertData.icon = 'question';
          alertData.icon = 'help';
          break;
      }
    }

    if(!alertData.iconColor|| alertData.iconColor === '') {
      switch(alertData.status) {
        case AlertStatus.error:
          alertData.iconColor = 'danger';
          break;
        case AlertStatus.success:
          alertData.iconColor = 'light';
          break;
        case AlertStatus.warning:
          alertData.iconColor = 'warning';
          break;
        case AlertStatus.question:
          alertData.iconColor = 'light';
          break;
      }
    }

    if(!alertData.title || alertData.title === '') {
      switch(alertData.status) {
        case AlertStatus.error:
          alertData.title = 'general.error';
          break;
        case AlertStatus.warning:
          alertData.title = 'general.warning';
          break;
      }
    }

    this._alertData = alertData;
  }

  get alertData(): IAlertData {
    return this._alertData ?? this.resetAlertData();
  }

  ngOnInit(): void {
    this.getAlert();
  }

  protected close(): void {
    this._alertData = this.resetAlertData();
    // Test Joaquin to use several alert elements
    this.alertService.close();
  }

  protected clickButton(button: IAlertDataButton): void {
    if (button.handler) {
      if (button.onClickLoading) {
        button.disabled = true;
      }
      if (button.onDismiss) {
        if (button.onDismiss === 'code') {
          button.handler(this.componentInputs.code);
        }
      } else {
        button.handler();
      }
    }
    if (button.closeButton) {
      this.close();
    }
  }

  protected isDisabled(button: IAlertDataButton): boolean {
    if (button.onClickLoading) {
      if (
        this.alertData.component === 'code' &&
        this.componentInputs.code === undefined
      ) {
        return true;
      }
    }
    return false;
  }

  private getAlert(): void {
    this.alertService.alertEvents$.subscribe((data: IAlertData) => {
      this.alertData = data;
      this.changeDetectorRef.detectChanges();
    });
  }

  private resetAlertData(): IAlertData {
    this.componentInputs = { code: undefined };
    return {
      show: false,
      status: AlertStatus.success,
      closeButton: true,
      text: undefined,
      title: undefined,
      buttons: undefined,
      component: undefined,
      componentInputs: undefined,
    };
  }
}
